import http from "@/settings/apiSettings"

class DOC_DocumenteDataService {
    save(data: any): Promise<any> {
        return http.clientDocumenteOdata.post("/DOC_Documente", data);
    }
    update(id: string, data: any): Promise<any> {
        return http.clientDocumenteOdata.put(`/DOC_Documente/${id}`, data);
    }
    genereazaDocumentDinComanda(dto: any): Promise<any> {
        return http.clientDocumente.post('doc/genereaza-din-comanda', dto);
    }
    genereazaFacturaProiect(dto: any): Promise<any> {
        return http.clientDocumente.post('doc/genereaza-factura-proiect', dto);
    }
    getDocumenteAsociateCandidati(documentId: string, text: string): Promise<any> {
        return http.clientDocumente.get(`/DOC_Documente/${documentId}/documente-asociate-candidati`, { params: { text } });
    }
    asociazaDocument(documentId: string, documentAsociatId: string): Promise<any> {
        return http.clientDocumente.post(`/DOC_Documente/${documentId}/asociaza`, { DocumentAsociatId: documentAsociatId });
    }
    dezasociazaDocument(documentId: string): Promise<any> {
        return http.clientDocumente.delete(`/DOC_Documente/${documentId}/asociere`);
    }
    getDocumenteGenerate(documentId: string): Promise<any> {
        return http.clientDocumente.get(`/DOC_Documente/${documentId}/documente-generate`);
    }
    getStructuraCurenta(): Promise<any> {
        return http.clientDocumente.get('/DOC_Documente/structura-curenta');
    }
}
export default new DOC_DocumenteDataService();
